/*
  TYOHAAR occasion rail — the "All N occasions" circle.

  WHAT IT REPLACED
    The circle was a link to a single collection. It said "All 12 occasions"
    and opened one, which is the gap between what the label promised and what
    happened. It now reveals the tiles that are already in the rail, hidden.

  WHICH TILES
    Every tile placed AFTER the panel tile in the block list. Ordering is the
    control, because it is the one a merchant already uses: drag a tile above
    the panel to show it from the start, below to tuck it behind the button.
    Liquid decides that and ships the markup with `hidden` already on; this
    only takes it off.

  WHY THE BUTTON THEN GOES AWAY
    It has nothing left to do. Leaving it there as a "show less" invites a
    shopper to put the thing back that they just asked for, which is not a
    decision anyone wants to make twice. The tiles stay out for the visit.

  NO FRAMEWORK, NO DEPENDENCY. Four lines of work behind a custom element so
  it cleans up after itself in the theme editor, where sections are thrown
  away and rebuilt on every change.
*/

if (!customElements.get('tyoh-occ-more')) {
  class TyohOccMore extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-occ-more]');
      if (!this.button) return;
      this.onClick = () => this.reveal();
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
    }

    reveal() {
      const rail = this.button.closest('.occ__rail');
      if (!rail) return;

      rail.querySelectorAll('[data-occ-hidden]').forEach((tile) => {
        tile.hidden = false;
        tile.removeAttribute('data-occ-hidden');
      });

      /*
        Focus moves to the first revealed tile before the button leaves.

        A keyboard user pressed something that is about to be removed from the
        page; without this their place is lost and focus falls back to the top
        of the document. Sending them to the first new tile is both where the
        change happened and where they were going.
      */
      const first = rail.querySelector('.occ__item--more .occ__link');
      this.button.setAttribute('aria-expanded', 'true');
      // The whole <li> goes, not just the button — a tile-shaped hole in the
      // row would be worse than the button it replaced.
      this.closest('[data-occ-panel]')?.remove();
      first?.focus();

      /*
        The arrows measure the rail on resize, and revealing tiles changes its
        scroll width without changing its box — so they would still think
        there is nothing to scroll to. A resize event is the signal they
        already listen for.
      */
      window.dispatchEvent(new Event('resize'));
    }
  }

  customElements.define('tyoh-occ-more', TyohOccMore);
}
